import { DateTime } from "luxon";

/**
 * Returns true if the DOB is valid (YYYY-MM-DD) and represents an age >= minAge.
 */
export function isAtLeastAge(dob: string | null | undefined, minAge: number): boolean {
  if (!dob) return false;
  const parsed = DateTime.fromFormat(dob, "yyyy-MM-dd");
  if (!parsed.isValid) return false;
  const minDate = DateTime.now().minus({ years: minAge }).startOf("day");
  return parsed.toMillis() <= minDate.toMillis();
}
